export enum TabKeys {
  OVERVIEW = 'overview',
  ONTOLOGIES = 'ontologies',
  METADATA = 'metadata',
  PHENOPACKET_JSON = 'phenopacket_json',
}
